import { Button, Paper, Tooltip, Typography } from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'
import { useTranslation } from 'react-i18next'

import { BaseNetworkButton } from './network-button.component'
import { ETranslationNs, IUserExposePrivateKeyRespDto } from 'src/types'
import { useCopy } from 'src/hooks'

import { useStyles as useStyles2 } from '../user-profile/change-password-modal/styles'
import { useStyles } from './styles'
import { HelperWrapper } from '../helper-wrapper'

interface PrivateKeyCardProps {
  wallet: IUserExposePrivateKeyRespDto
}

const PrivateKeyCard = ({ wallet }: PrivateKeyCardProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const classes2 = useStyles2()
  const handleCopy = useCopy(wallet.privateKey)

  return (
    <div className={classes.mainWrapper}>
      <div className={classes.keyCardWrapper}>
        <Typography className={classes2.title}>
          <HelperWrapper t="expose-pk-form-title" ns={ETranslationNs.UserProfile} />
        </Typography>
        <Paper variant="outlined" className={classes.keyTextWrapper}>
          <Typography className={classes.keyText} color="text.secondary">
            {wallet.privateKey}
            <Tooltip
              className={classes.helpIconWrapper}
              title={t('expose-pk-form-tooltip-warning.v')}
            >
              <HelpIcon className={classes.helpIcon} />
            </Tooltip>
          </Typography>
        </Paper>
        {wallet.is_custodial && (
          <div>
            <Typography className={classes.connectionHelpText}>
              <HelperWrapper t="expose-pk-form-tooltip-help" />
            </Typography>
            {window.ethereum && (
              <div className={classes.connectionButtonWrapper}>
                <BaseNetworkButton />
              </div>
            )}{' '}
          </div>
        )}
      </div>
      <Button variant="contained" onClick={handleCopy}>
        <HelperWrapper t="copy-button-text" />
      </Button>
    </div>
  )
}

export { PrivateKeyCard }
